const jssStyles = theme => ({
  container: {
    position: 'absolute',
  },
})

export default jssStyles
